import { SVGIconComponent } from './types';

export const Note: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="timeline/event-note" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M20,4 L20,14 L14,14 L14,20 L4,20 L4,4 L20,4 Z M20,16 L16,20 L16,16 L20,16 Z"
        id="Combined-Shape"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
